import React, { Dispatch, SetStateAction } from "react";
import Typography from "../../ui/widgets/typography";
import IconButton from "../../ui/widgets/button-icon";
import Button from "../../ui/widgets/button";
import Dialog from "../../ui/widgets/dialog";
import { useMessageSource } from "react-message-source";

interface LeavingSwisscardModalProps {
  linkToService: string;
  setIsModalOpen: Dispatch<SetStateAction<boolean>>;
  isModalOpen: boolean;
}

export const LeavingSwisscardModal = ({
  isModalOpen,
  setIsModalOpen,
  linkToService,
}: LeavingSwisscardModalProps): React.JSX.Element => {
  const { getMessage } = useMessageSource();

  return (
    <Dialog open={isModalOpen}>
      <div className="scd-dialog-header">
        <Typography variant="h2">
          {getMessage("DocumentUpload.modal.leaving-swisscard-title")}
        </Typography>
        <IconButton
          onClick={() => setIsModalOpen(!isModalOpen)}
          title="Close"
          icon="close"
        />
      </div>
      <div>
        <Typography variant="body1">
          <div
            dangerouslySetInnerHTML={{
              __html: getMessage(
                "DocumentUpload.modal.leaving-swisscard.paragraph",
              ),
            }}
          />
        </Typography>
        <div className="scd-section-pusher-sm">
          <Typography variant="body1">
            {getMessage("DocumentUpload.modal.leaving-swisscard.paragraph-1")}
          </Typography>
        </div>
      </div>
      <div className="scd-dialog-footer">
        <Button onClick={() => setIsModalOpen(!isModalOpen)} kind="secondary">
          {getMessage("Onboarding.back")}
        </Button>
        <Button
          onClick={() => {
            setIsModalOpen(false);
            window.open(linkToService, "_blank");
          }}
          kind="primary"
        >
          {getMessage("Onboarding.continue")}
        </Button>
      </div>
    </Dialog>
  );
};
